module.exports = __webpack_public_path__ + "img/slide_3.1968cb0a.jpg";